import { render, staticRenderFns } from "./InternalCommsInfo.vue?vue&type=template&id=b82f3d12&scoped=true"
import script from "./InternalCommsInfo.vue?vue&type=script&lang=js"
export * from "./InternalCommsInfo.vue?vue&type=script&lang=js"
import style0 from "./InternalCommsInfo.vue?vue&type=style&index=0&id=b82f3d12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82f3d12",
  null
  
)

export default component.exports